<template>
	<PatientMicrohabitsPanelMenu :type="MICROHABIT_FOOD_TYPE"/>
</template>

<script>
import PatientMicrohabitsPanelMenu from '@/components/microhabits/PatientMicrohabitsPanelMenu'
import { MICROHABIT_FOOD_TYPE } from '@/constants/microhabitTypes'

export default {
	components: {
		PatientMicrohabitsPanelMenu
	},
	data () {
		return {
			MICROHABIT_FOOD_TYPE
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/webapp/patient/foods/PatientFoodsPanelMenu.vue